import { Choice, Maybe, Space } from "types";

export const mapSpacesToChoices = (spaces: Maybe<Space[]>): Choice[] => {
  if (!spaces) {
    return [];
  }

  return spaces.map((space) => ({
    id: space.id,
    name: space.name
  }));
};
